import { render, staticRenderFns } from "./AthleteEditInfoDialog.vue?vue&type=template&id=b9ab2146&"
import script from "./AthleteEditInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./AthleteEditInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports